import { useState, useEffect, useRef } from "react";

// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

import { putData, uploadData } from "Utils/server";
import { getAuthorizationHeader } from "Utils/helpers";

import unknownLogo from "assets/images/providers/unknown.png";

function LogoHandler({ id, url, allowCreate }) {
  const [mode, setMode] = useState("preview");
  const [file, setFile] = useState();
  const [fileUrl, setFileUrl] = useState();
  const [fileSelected, setFileSelected] = useState();
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState("");

  const uploadInput = useRef(null);

  function handleImageChange(e) {
    e.preventDefault();
    //console.log(e.target.files);
    setFileSelected(e.target.files[0]);
    setFile(URL.createObjectURL(e.target.files[0]));
    setProgress(0);
    setMessage("");
  }

  function cancelEdit(e) {
    e.preventDefault();
    setMode("preview");
    uploadInput.current.value = null;
    setFile(null);
  }

  async function removeFile(e) {
    e.preventDefault();

    let updatePlatformEndpoint = `/api/v1/platforms/${id}/logo`;
    let response = await putData(
      updatePlatformEndpoint,
      { logo: null },
      {
        Authorization: getAuthorizationHeader(),
      }
    );

    setFileUrl(null);
    setMode("preview");
    uploadInput.current.value = null;
    setFile(null);
  }

  async function uploadFile(e) {
    setProgress(0);

    // Create an object of formData
    let formData = new FormData();

    formData.append("file", fileSelected);

    // Request made to the backend api
    // Send formData object
    let updatePlatformEndpoint = `/api/v1/files/upload`;
    let response = await uploadData(
      updatePlatformEndpoint,
      formData,
      {
        Authorization: getAuthorizationHeader(),
      },
      (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      }
    )
      .then((response) => {
        setMessage(response.data.message);

        updateLogoToDB();
      })
      .catch((err) => {
        setProgress(0);

        if (err.response && err.response.data && err.response.data.message) {
          setMessage(err.response.data.message);
        } else {
          setMessage("Could not upload the Image!");
        }

        setFileSelected(undefined);
      });
  }

  async function updateLogoToDB() {
    let updatePlatformEndpoint = `/api/v1/platforms/${id}/logo`;
    let response = await putData(
      updatePlatformEndpoint,
      { logo: fileSelected.name },
      {
        Authorization: getAuthorizationHeader(),
      }
    );

    setFileUrl(process.env.REACT_APP_AUTH_URL + "/api/v1/files/preview/" + fileSelected.name);
    setMode("preview");
    uploadInput.current.value = null;
    setFile(null);
  }

  useEffect(() => {
    if (url) {
      setFileUrl(url);
    }
  }, [url]);

  return (
    <Grid
      item
      xs={12}
      sm={2}
      className="platform-fields-holder"
      style={{ display: allowCreate ? "" : "none" }}
    >
      <Grid item xs={12} style={{ display: "flex" }}>
        <SoftTypography variant="caption" sx={{ fontWeight: "bold" }}>
          Platform Logo:
        </SoftTypography>
      </Grid>
      <Grid item xs={12} sx={{ display: mode == "edit" ? "none" : "" }}>
        <div
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            display: "flex",
            marginTop: "5px",
            marginBottom: "5px",
            border: "1px solid #cecece",
            padding: "20px",
            backgroundColor: "#f8f8f8",
          }}
        >
          <img
            src={fileUrl ? fileUrl : unknownLogo}
            style={{ margin: "auto", maxWidth: "200px", maxHeight: "90px" }}
          />
        </div>
        <Grid item xs={12} style={{ display: "flex" }}>
          <Grid item xs={6} sx={{ display: fileUrl ? "flex" : "none" }}>
            <SoftButton size="small" color="error" sx={{ width: "100%" }} onClick={removeFile}>
              Remove
            </SoftButton>
          </Grid>
          <Grid item xs={fileUrl ? 6 : 12} sx={{ textAlign: "right" }}>
            <SoftButton
              size="small"
              color="warning"
              sx={{ width: "100%" }}
              onClick={() => setMode("edit")}
            >
              Change
            </SoftButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sx={{ display: mode == "edit" ? "" : "none" }}>
        <input size="small" ref={uploadInput} type="file" onChange={handleImageChange} />
        <div
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            display: "flex",
            marginTop: "5px",
            marginBottom: "5px",
            border: "1px solid rgb(206, 206, 206)",
            padding: "20px",
            backgroundColor: "rgb(248, 248, 248)",
            minHeight: "80px",
          }}
        >
          {" "}
          <SoftTypography
            variant="caption"
            sx={{ display: file ? "none" : "", width: "100%", textAlign: "center" }}
          >
            No File Selected
          </SoftTypography>
          <img src={file} style={{ margin: "auto", maxWidth: "200px", maxHeight: "105px" }} />
        </div>
        <Grid item xs={12} style={{ display: "flex" }}>
          <Grid item xs={file ? 6 : 12}>
            <SoftButton size="small" color="error" sx={{ width: "100%" }} onClick={cancelEdit}>
              Cancel
            </SoftButton>
          </Grid>
          <Grid item xs={6} sx={{ textAlign: "right", display: file ? "flex" : "none" }}>
            <SoftButton size="small" color="success" sx={{ width: "100%" }} onClick={uploadFile}>
              upload
            </SoftButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

// typechecking props for UserInfo
LogoHandler.propTypes = {
  id: PropTypes.number,
  url: PropTypes.string,
  allowCreate: PropTypes.bool,
};

export default LogoHandler;
